export const getCustomFields = (
    data, listId
) => {
    const fieldsToReturn = []
    if (!customFields[listId]) {
        return fieldsToReturn;

    }
    customFields[listId].forEach((field) => {
        if (!data[field.dataKey] && !field.defaultValue) {
            return;
        }
        fieldsToReturn.push({
            'name': field.name,
            'value': data[field.dataKey] || field.defaultValue
        })
    })
    return fieldsToReturn
};

const customFields = {
    '3z7a233ebb016fa00d759bab4e95a40d8a4a28f3ad99b749d44abada86729f4084': [
        {
            'name': 'First Name',
            'defaultValue': '',
            'dataKey': 'firstName'
        },
        {
            'name': 'Last Name',
            'defaultValue': '',
            'dataKey': 'lastName'
        },
        {
            'name': 'Phone',
            'defaultValue': '',
            'dataKey': 'mobilePhone'
        },
        {
            'name': 'email _optin',
            'defaultValue': 'Yes',
            'dataKey': ''
        },
    ]
}
